// TODO: Change the way timeline boxes are created by hardcoding the div for each actual timeine element.

import { useSelector } from "react-redux";
import classNames from "classnames";
import TimelineBox from "./TimelineBox";

const colorClasses = ["cyan-bg", "red-bg", "blue-bg"];

function Timeline({ className }) {
  const { timelineData } = useSelector((state) => state.app);
  const timelineBoxes = [];
  let i = 0;
  while (i < timelineData.length) {
    if (i + 1 < timelineData.length) {
      timelineBoxes.push([
        <div
          className={classNames("ps-timeline-circle", colorClasses[i % 3])}
          key={i}
        >
          <TimelineBox
            className="ps-timeline-box-right ps-timeline-box-mid"
            timelineBoxData={timelineData[i]}
          />
        </div>,
        <div className="ps-timeline-shorter-line" key={`line${i}`}></div>,
      ]);
      i++;
      timelineBoxes.push([
        <div
          className={classNames("ps-timeline-circle", colorClasses[i % 3])}
          key={i}
        >
          <TimelineBox
            className="ps-timeline-box-right ps-timeline-box-mid"
            timelineBoxData={timelineData[i]}
          />
        </div>,
        i + 1 < timelineData.length && (
          <div className="ps-timeline-line" key={`line${i}`}></div>
        ),
      ]);
      i++;
    } else {
      timelineBoxes.push([
        <div
          className={classNames("ps-timeline-circle", colorClasses[i % 3])}
          key={i}
        >
          <TimelineBox
            className="ps-timeline-box-right ps-timeline-box-mid"
            timelineBoxData={timelineData[i]}
          />
        </div>,
      ]);
      i++;
    }
  }
  return (
    <div
      className={classNames(
        "w-max mt-16 pm-timeline",
        className
      )}
    >
      <div className="flex flex-col items-center w-max">{timelineBoxes}</div>
    </div>
  );
}

export default Timeline;
